import styled from "styled-components";

interface Props {
  width?: number;
  active?: boolean | "hover";
  borderWidth?: number;
}

export const CompleteBriefIconSvg = (props: Props) => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_10521_11401)">
        <path
          d="M44.0625 22.5C44.0625 10.5914 34.4086 0.9375 22.5 0.9375C10.5914 0.9375 0.9375 10.5914 0.9375 22.5C0.9375 34.4086 10.5914 44.0625 22.5 44.0625C34.4086 44.0625 44.0625 34.4086 44.0625 22.5Z"
          stroke="url(#paint0_linear_10521_11401)"
          stroke-width={props.borderWidth || 2}
        />
        <path
          d="M17.0776 30.3081C16.2489 30.3081 15.6366 30.1102 15.2407 29.7144C14.8449 29.3185 14.647 28.7062 14.647 27.8774V25.8735C14.647 25.688 14.5851 25.5303 14.4614 25.4004L13.042 23.9717C12.4544 23.3903 12.1606 22.8213 12.1606 22.2646C12.1606 21.708 12.4544 21.1359 13.042 20.5483L14.4614 19.1196C14.5851 18.9897 14.647 18.8351 14.647 18.6558V16.6426C14.647 15.8076 14.8449 15.1953 15.2407 14.8057C15.6366 14.4098 16.2489 14.2119 17.0776 14.2119H19.0815C19.2733 14.2119 19.431 14.1501 19.5547 14.0264L20.9834 12.6069C21.571 12.0194 22.14 11.7256 22.6904 11.7256C23.2471 11.7256 23.8192 12.0194 24.4067 12.6069L25.8354 14.0264C25.9653 14.1501 26.123 14.2119 26.3086 14.2119H28.3125C29.1475 14.2119 29.7598 14.4129 30.1494 14.8149C30.5452 15.2108 30.7432 15.82 30.7432 16.6426V18.6558C30.7432 18.8351 30.8081 18.9897 30.938 19.1196L32.3481 20.5483C32.9357 21.1359 33.2295 21.708 33.2295 22.2646C33.2357 22.8213 32.9419 23.3903 32.3481 23.9717L30.938 25.4004C30.8081 25.5303 30.7432 25.688 30.7432 25.8735V27.8774C30.7432 28.7124 30.5452 29.3247 30.1494 29.7144C29.7536 30.1102 29.1413 30.3081 28.3125 30.3081H26.3086C26.123 30.3081 25.9653 30.373 25.8354 30.5029L24.4067 31.9224C23.8192 32.5037 23.2471 32.7944 22.6904 32.7944C22.14 32.8006 21.571 32.5099 20.9834 31.9224L19.5547 30.5029C19.431 30.373 19.2733 30.3081 19.0815 30.3081H17.0776ZM17.0776 28.833H19.5732C19.8577 28.833 20.0928 28.932 20.2783 29.1299L22.0225 30.8833C22.3193 31.174 22.542 31.3193 22.6904 31.3193C22.8451 31.3193 23.0708 31.174 23.3677 30.8833L25.1211 29.1299C25.3066 28.932 25.5386 28.833 25.8169 28.833H28.3125C28.7269 28.833 28.9897 28.7773 29.1011 28.666C29.2124 28.5547 29.2681 28.2918 29.2681 27.8774V25.3818C29.2681 25.1097 29.367 24.8778 29.5649 24.686L31.3184 22.9419C31.609 22.645 31.7544 22.4193 31.7544 22.2646C31.7544 22.11 31.609 21.8843 31.3184 21.5874L29.5649 19.8433C29.367 19.6453 29.2681 19.4103 29.2681 19.1382V16.6426C29.2681 16.2344 29.2124 15.9746 29.1011 15.8633C28.9897 15.7458 28.7269 15.687 28.3125 15.687H25.8169C25.5386 15.687 25.3066 15.5911 25.1211 15.3994L23.3677 13.646C23.0708 13.3553 22.8451 13.21 22.6904 13.21C22.542 13.21 22.3193 13.3553 22.0225 13.646L20.2783 15.3994C20.0928 15.5911 19.8577 15.687 19.5732 15.687H17.0776C16.6571 15.687 16.3911 15.7427 16.2798 15.854C16.1746 15.9653 16.1221 16.2282 16.1221 16.6426V19.1382C16.1221 19.4103 16.0262 19.6453 15.8345 19.8433L14.0811 21.5874C13.7842 21.8843 13.6357 22.11 13.6357 22.2646C13.6357 22.4193 13.7842 22.645 14.0811 22.9419L15.8345 24.686C16.0262 24.8778 16.1221 25.1097 16.1221 25.3818V27.8774C16.1221 28.2918 16.1777 28.5547 16.2891 28.666C16.4004 28.7773 16.6632 28.833 17.0776 28.833ZM21.6885 26.6621C21.5339 26.6621 21.3916 26.6281 21.2617 26.5601C21.138 26.492 21.0174 26.3838 20.8999 26.2354L18.6362 23.4521C18.494 23.2604 18.4229 23.0687 18.4229 22.877C18.4229 22.6729 18.4909 22.4997 18.627 22.3574C18.7692 22.209 18.9393 22.1348 19.1372 22.1348C19.2671 22.1348 19.3846 22.1626 19.4897 22.2183C19.6011 22.2677 19.7124 22.3667 19.8237 22.5151L21.6514 24.8809L25.5015 18.7021C25.6746 18.4238 25.8911 18.2847 26.1509 18.2847C26.3426 18.2847 26.5158 18.3465 26.6704 18.4702C26.825 18.5939 26.9023 18.7578 26.9023 18.9619C26.9023 19.0671 26.8776 19.1722 26.8281 19.2773C26.7848 19.3763 26.7354 19.4691 26.6797 19.5557L22.4399 26.2354C22.2544 26.5199 22.0039 26.6621 21.6885 26.6621Z"
          fill="#3D3C5A"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10521_11401"
          x1="4.37308e-08"
          y1="22.5005"
          x2="44.9992"
          y2="22.5005"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.13" stop-color="#FA3CAB" />
          <stop offset="0.24" stop-color="#F94C94" />
          <stop offset="0.57" stop-color="#F87C54" />
          <stop offset="0.81" stop-color="#F79A2C" />
          <stop offset="0.94" stop-color="#F7A61D" />
        </linearGradient>
        <clipPath id="clip0_10521_11401">
          <rect width="45" height="45" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CompleteBriefIcon = styled(CompleteBriefIconSvg)`
  & path:first-of-type {
    stroke: ${(p) => p.theme.color.typography.secondary}80;
  }

  & path:nth-of-type(2) {
    fill: ${(p) => p.theme.color.typography.secondary};
  }

  .active & path:first-of-type {
    stroke: url(#paint0_linear_10521_11358);
  }

  .active & path:nth-of-type(2) {
    fill: ${(p) => p.theme.color.typography.text};
  }
`;
